"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const AutocompleteField_1 = __importDefault(require("@/components/AutocompleteField"));
const style_1 = require("./style");
function SearchCountriesAutocomplete({ options, onOpen, isOpen, onClose, value, name, id, onChange, filterOptions }) {
    return (react_1.default.createElement(AutocompleteField_1.default, { options: options, inputStyles: style_1.inputStyles, onChange: onChange, label: "Select Country", autocompleteStyles: style_1.style, onOpen: onOpen, placeholder: "Country", isOpen: isOpen, value: value, filterOptions: filterOptions, id: id, onClose: onClose, name: name }));
}
exports.default = SearchCountriesAutocomplete;
